// import 'jquery/dist/jquery';
import 'uikit';
import * as interactiveFunction from "interactive_function.js";

// import 'es6-promise-promise';

/**************************************************************
interface interactive
**************************************************************/
interactiveFunction.clear_storage( true );

window.gameTimer = null;
window.updateList = null;
window.pauseInterval = false;
window.winner_popup_is_open = false;
window.audioEnabled = false;
window.callerVoice = new Audio();
window.formGameModal = false;
window.addCardModal = false;
// window.audioBaseUrl = callerGlobals.general.rootURL + 'audio/draw/' + site_lang.substr( 0, 2 ) + '/';

var isDragging = false,
	deviceEventType = "";

$('.modalSelector').on({
	'center': true,
});

$(document).on('keyup', '#phone', function() {
	this.value = this.value
		.match(/\d*/g).join('')
		.match(/(\d{0,3})(\d{0,3})(\d{0,4})/).slice(1).join('-')
		.replace(/-*$/g, '')
	;
});

if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
	deviceEventType = 'touchstart';

	//check if the device was locked
	//https://stackoverflow.com/questions/15959244/is-it-possible-in-javascript-to-detect-when-the-screen-is-turned-off-in-the-an
	var lastInterval = interactiveFunction.getTime();
	var checkUserPhoneLock = setInterval(phoneLockChecker, 1000);
} else {
	//If its not a mobile device use 'click'
	deviceEventType = 'click';
}

function phoneLockChecker() {
	var now = interactiveFunction.getTime();
	var diff = now - lastInterval;
	var offBy = diff - 1000;
	lastInterval = now;


	if(offBy > 100) {
		clearInterval(checkUserPhoneLock);
		$('.uk-modal').remove();

		UIkit.modal.alert( callerGlobals.i18n.not_sync, {
			center: true,
			labels: {
				Ok: callerGlobals.i18n.gameTheGame,
			}
		}).on('hide.uk.modal', function() {
			interactiveFunction.showLoading();
			location.reload();
		});
	}
}

$(document).on( deviceEventType, '.click', function(event){
	if( ' deviceEventType' == 'click' ){
		event.preventDefault();
	}

	let currentCase = $(this);

	if( callerGlobals.general.canClick == true ) {
		if( ! currentCase.hasClass("clicked") && ! currentCase.hasClass("bingo") && ! currentCase.hasClass("noaction") ) {
			interactiveFunction.clickBingoBox( currentCase, event );
		}
	}
});

$(document).on( deviceEventType, '.noaction', function(){
	var $this = $(this);

	$($this).toggleClass('no-case');

	setTimeout(function(){
		$($this).toggleClass('no-case', false);
	}, 250);
});




$(document).on( deviceEventType, "#exitGame", function(event){
	UIkit.modal.confirm( callerGlobals.i18n.callerExitTooltip,
		function() {
			window.location.href = callerGlobals.general.gamesListingURL;
		}, function(){

		}, {
			center:true,
			labels:{
				Cancel: callerGlobals.i18n.cancelLabel,
				Ok: callerGlobals.i18n.exitGame,
			}
		}
	);
});


$(document).on( deviceEventType, "#toggleVoice", function(event){
	if( $(this).data( 'state' ) == 1 ) {
		$(this).data( 'state', 0 )
			.addClass('disabled')
			.removeClass('uk-icon-volume-up')
			.addClass('uk-icon-volume-off');

		window.audioEnabled = 0;
	} else {
		$(this).data( 'state', 1 )
			.removeClass('disabled')
			.removeClass('uk-icon-volume-off')
			.addClass('uk-icon-volume-up');
			
		window.audioEnabled = 1;

		if( window.callerVoice.src == '' ) {
			window.callerVoice.play();
		}
	}
});

$(document).on( deviceEventType, ".column-header", function( event ){
	let column_header = $(this);
	var letter = column_header.children().attr('data-origin-letter');

	$(".header-selected").removeClass("header-selected");
	$(".row-header .column-" + $(this).data('column')).addClass("header-selected");

	$(".column").each(function(){
		let column = $(this);

		if( column.hasClass('column-header') === false ) {
			if( $(this).hasClass( 'origin-letter-' + letter ) ) {
				column.show().addClass('column-opened');
			} else if( column.hasClass('column-opened') ) {
				column.hide().removeClass('column-opened');
			} else {
				column.hide();
			}
		}
	});
});

$(document).on( deviceEventType, ".header-selected", function(event) {
	var letter = $(this).children().attr('data-origin-letter');

	$(".column").each(function(){
		if( $(this).hasClass('column-header') === false ){
			if( $(this).hasClass('origin-letter-' + letter) ) {
				$(this).removeClass('column-opened');
			} else {
				$(this).show();
			}
		}
	});

	$(this).closest('.cards-wrapper').find('.header-selected').removeClass("header-selected");
	$(this).removeClass("header-selected");
});

// Permet d'obtenir une carte supplémentaire lorsqu'on est dans un bingo avec code, qu'on en possède plus d'un et que l'organisateur le permet
$(document).on( 'submit', '.passwordForNewCard', function(event){
	event.preventDefault();

	let thisForm = $(this),
		theButton = thisForm.find( 'input[type=submit]' );

	theButton.prop( 'disabled', true );

	$.post( thisForm.attr('action'), thisForm.serialize() )
		.done(function( data ){
			if( data.result === 'success' ) {
				$('.uk-modal').hide();
				interactiveFunction.showLoading();
				location.reload();
			} else {
				thisForm.find( '.message' ).text( data.message ).show( 150 );
				theButton.prop( 'disabled', false );
			}
		})
		.fail( function() {
			UIkit.modal.alert( $('#textContainer').data('error-five-hundred'), { center: true } ).on({
				'hide.uk.modal': function() {
					if( window.formGameModal ) {
						window.formGameModal.hide();
					}

					interactiveFunction.showLoading();
					location.reload();
				}
			});
		} );

});

$(function(){

	if(
		localStorage.getItem('active_winning_ways_showed') === null ||
		( localStorage.getItem('active_winning_ways_showed') !== null && localStorage.getItem('active_winning_ways_showed') != callerGlobals.caller.id )
	) {
		localStorage.setItem('active_winning_ways_showed', callerGlobals.caller.id);
		interactiveFunction.show_active_winning_ways();
	}

	localStorage.setItem('gameIteration', callerGlobals.caller.iteration);

	window.addEventListener("load",function() {
		// Set a timeout...
		setTimeout(function(){
			// Hide the address bar!
			window.scrollTo(0, 1);

			/*$('.square').each(function(){
				$(this).attr('width', Math.ceil( $(this).height() ) );
			});*/
		}, 50);
	});

	sessionStorage.clear();
	let free = localStorage.getItem("free");
	let timeLoop = 2000;

	let $clicked = $(".clicked");
	let $win = $(".bingo");

	let isclicked = ( $clicked.length > 0 ),
		idBox 	  = null,
		isWin 	  = ( $win.length > 0),
		nbRequest = 0;

	window.gameTimer = setInterval(function(){
		if( window.pauseInterval === false ) {
			window.pauseInterval = true;
			interactiveFunction.stateGame( nbRequest );
		}

		nbRequest++;
	}, timeLoop);

	var visible = vis();

	$(window).on("focusin", function () {
		interactiveFunction.updPickList();
	} );

	vis( function() {
		if( vis() ) {
			interactiveFunction.updPickList();
		}
	} );


	// Permettre le changement d'onglet / carte
	$('.tabs .tab-btn:not( .tab-btn-add )').click( function() {
		$(this).closest( '.tabs' ).find( '.tab-btn.active' ).removeClass('active');
		$(this).addClass( 'active' );
		$(this).removeClass( 'highlight' );
		$(this).removeClass( 'wins' );

		$('.cards').scrollLeft( document.getElementById( 'card_' + $(this).data('card-id') ).offsetLeft );

		let relatedCard = $( '#card_' + $(this).data('card-id') );

		setTimeout( function() {
			relatedCard.find('.new').each( function() {
				$(this).removeClass( 'new' );
			} );
		}, 3000 );
	} );

	$('#tab_btn_add').click( function() {
		interactiveFunction.passwordForNewCard();
	} );

	const container = document.querySelector( '.cards-wrapper' );
	const children = Array.from( container.querySelectorAll( '.card' ) );

	// Create an IntersectionObserver to observe each child element
	const observer = new IntersectionObserver( ( entries ) => {
		entries.forEach( ( entry ) => {
			if ( entry.isIntersecting ) {
				// console.log( 'In viewport:', entry );
				let currentItem = entry.target;

				container.querySelector('.active').classList.remove( 'active' );
				currentItem.classList.add('active');

				// On va aller mettre le bon onglet actif
				let newActiveTab = document.getElementById( 'tab_btn_' + currentItem.dataset.cardId );

				document.querySelector( '.tabs .tab-btn.active' ).classList.remove('active');
				newActiveTab.classList.add('active');
				newActiveTab.classList.remove('wins');
				newActiveTab.classList.remove('highlight');

				let relatedCard = $( '#card_' + newActiveTab.dataset.cardId );

				setTimeout( function() {
					relatedCard.find('.new').each( function() {
						$(this).removeClass( 'new' );
					} );
				}, 3000 );
			}
		});
	}, {
		root: container,  // Set the root to the scrollable container
		threshold: 0.5    // Trigger when at least 50% of the child is in the viewport
	});

	// Observe each child element in the container
	children.forEach( ( child ) => observer.observe( child ) );

});

$(document).on( deviceEventType, '#previous_draw', function(event){
	$(".draws-list-container").fadeIn(250);
});

$('.draws-list-wrapper').on( deviceEventType, '.close-button', function(event){
	$(".draws-list-container").fadeOut(250);
});

var vis = (function(){
	var stateKey, eventKey, keys = {
		hidden: "visibilitychange",
		webkitHidden: "webkitvisibilitychange",
		mozHidden: "mozvisibilitychange",
		msHidden: "msvisibilitychange"
	};
	for( stateKey in keys ) {
		if( stateKey in document ) {
			eventKey = keys[stateKey];
			break;
		}
	}

	return function(c) {
		if( c ) document.addEventListener( eventKey, c );
		return ! document[ stateKey ];
	};
})();

// Bouton Click All
$('#clickAll').on('click', function( e ) {
	e.preventDefault();

	let clickedBingoBoxes = $('.cards .card .case.click:not( .clicked )');

	if( clickedBingoBoxes.length > 0 ) {
		interactiveFunction.clickBingoBoxes( clickedBingoBoxes );
	}

} );

document.addEventListener('clickmove', function (event) {
	if (event.scale !== 1) { event.preventDefault(); }
}, false);
